import React, { useEffect, useState } from "react";
import { getTrainingMaterialsByEmail ,getGroups } from "../Service/apiService";
import { useMsal } from "@azure/msal-react";
import PDFPopup from "../component/PDFPopup.js";
import UserDropdown from "../component/UserDropdown.js";
import UserManualSection from "../component/UserManualSection.js";
import TrainingVideosSection from "../component/TrainingVideosSection.js";
import ResizableDropdown from "../component/ResizableDropdown.js";
import { loginRequest } from "../Service/authConfig.js";
import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import toast from "react-hot-toast";
import ERPReleasePopup from "../component/ERPReleasePopup.js";
 

function HomePage() {
  const [materials, setMaterials] = useState([]);
  const [groups, setGroups] = useState([]);
  const [error, setError] = useState(null);
  const { accounts, instance ,inProgress } = useMsal();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const navigate = useNavigate();
  const [selectedGroup, setSelectedGroup] = useState("2");
  const [searchText, setSearchText] = useState("");
  const [showERPPopup, setShowERPPopup] = useState(false); 

  const user = accounts.length > 0 ? accounts[0] : null;
  
  const isIosSafari = () => {
    const ua = navigator.userAgent;
    
    return (
      /iP(ad|hone|od)/.test(ua) &&
      /WebKit/.test(ua) &&
      !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua)
    );
  };

  // Function to check if popup should be shown based on date range
  const shouldShowPopup = () => {
    const today = new Date();
    debugger
    today.setHours(0, 0, 0, 0); // Reset time to midnight for accurate date comparison
    
    // Set the start date (today)
    const startDate = new Date('2026-01-19'); // Today's date
    startDate.setHours(0, 0, 0, 0);
    
    // Set the end date (3 days from now)
    const endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 3); // Add 3 days
    
    // Check if today is within the date range
    return today <= endDate;
  };

  // Show ERP popup when SHAML Human Capital is selected and within date range
  useEffect(() => {
    debugger
 
      // Check if we're within the 3-day window
      if (!shouldShowPopup()) {
        return; // Don't show popup if outside date range
      }
setShowERPPopup(true);
      // Check if popup was already shown today
      // const popupShownDate = localStorage.getItem('erpPopupShownDate');
      // const today = new Date().toDateString();
      
      // if (popupShownDate !== today) {
      //   setShowERPPopup(true);
      //   localStorage.setItem('erpPopupShownDate', today);
      // }
   
  }, [ ]);

  useEffect(() => {
    const doLoginAndLoadData = async () => {
      try {
        const accounts = instance.getAllAccounts();

        if (accounts.length === 0) {
          // Show loading toast for login
          //  const loginToastId = toast.loading("Logging in...");
          if (isIosSafari()) {
            instance.loginRedirect(loginRequest);
          } else {
            await instance.loginPopup(loginRequest); 
          }
          //toast.dismiss(loginToastId);
          // toast.success("Login successful!");
        }

        // Show loading toast for data fetching
        //const dataToastId = toast.loading("Loading training materials and groups...");
        const [materialsData, groupsData] = await Promise.all([
          getTrainingMaterialsByEmail(user.username),
          getGroups(),
        ]);
        //  toast.dismiss(dataToastId);

        setMaterials(materialsData);
        setGroups(groupsData);
      } catch (err) {
        toast.dismiss();
        console.error("Failed to load data", err);

        if (err.errorCode === "interaction_in_progress") {
          toast("Login is already in progress. Please wait.", { icon: "⏳" });
        } else {
          toast.error("Unable to load training materials or groups.");
          setError("Unable to load training materials or groups.");
        }
      }
    };

    if (inProgress === InteractionStatus.None && user) {
      doLoginAndLoadData();
    }
  }, [inProgress, instance, user]);

  // console.log("window.innerWidth",window.innerWidth);

  const handleLogout = () => {
    instance.logoutPopup().catch((e) => {
      console.error(e);
    });
    navigate("/login");
  };
  
  const fileUrl = '/files/SHAML-how to login.pdf'; 
     
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
 
  const filteredMaterials = materials.filter((material) => {
    
    const matchesGroup =
      !selectedGroup || material.groupID?.toString() === selectedGroup;
    const matchesSearch =
      !searchText ||
      material.materialName?.toLowerCase().includes(searchText.toLowerCase());
    return matchesGroup && matchesSearch;
  });

  return (
    <div>
      <div className=" bg-innerbg bg-cover bg-center bg-no-repeat h-screen w-screen">
        <header className="bg-white ">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex-shrink-0">
                <a href="/" className="text-xl font-bold text-blue-600">
                  <img
                    src="images/logo.svg"
                    alt="Logo"
                    className="h-8 sm:h-10 lg:h-12 w-auto" // Responsive height
                  />
                </a>
              </div>
              
              <UserDropdown user={user} handleLogout={handleLogout} />
            </div>
          </div>
        </header>

        <div className="Content pt-20 md:pt-10 max-xs:pt-5">
          {/* <h3 className="text-primary-500 text-[40px] font-bold w-full w-100 text-center max-xs:text-2xl">Hello, Welcome Back...!</h3> */}
          <p className="text-[#3A3535] w-full text-center md:text-sm 2xl:text-2xl md:pt-3 pt-6 max-xs:px-2">
            <span className="text-primary-500 font-bold">Shaml Platform </span> 
            is a unified system that integrates 
            <span className="text-primary-500 font-bold"> HR, Finance, Procurement, and Project System</span> 
            <br/>Management to support and grow the AWJ business. 
          </p>
 
          <div className="flex gap-3 flex-row justify-center pt-6 max-xs:grid max-xs:grid-cols-2 max-xs:text-center max-xs:px-4 md:px-4">
            <a href="https://shaml-HC.awjholding.com" target="_blank">
              <div className="bg-primary-50/50 flex-col rounded-lg content-center items-center gap-1  md:px-3  md:py-2   xl:px-6 xl:py-4 2xl:px-6 2xl:py-4  flex max-xs:p-4">
                <img className="" src="images/hr.svg"/>
                <label className="font-semibold  text-primary-500 text-center">SHAML Human Capital</label>
              </div>
            </a>
 
            <a href="https://shamlcore.awjholding.com/sap/bc/ui2/flp" target="_blank">
              <div className="bg-primary-50/50 flex-col rounded-lg content-center items-center gap-1  md:px-3  md:py-2   xl:px-6 xl:py-4 2xl:px-6 2xl:py-4  flex max-xs:p-4">
                <img className="" src="images/procurement.svg"/>
                <label className="font-semibold  text-primary-500 text-center">SHAML Procurement</label>
              </div>
            </a>
 
            <a href="https://shamlcore.awjholding.com/sap/bc/ui2/flp" target="_blank">
              <div className="bg-primary-50/50 flex-col rounded-lg content-center items-center gap-1  md:px-3  md:py-2   xl:px-6 xl:py-4 2xl:px-6 2xl:py-4  flex max-xs:p-4">
                <img className="" src="images/finance.svg"/>
                <label className="font-semibold text-primary-500 text-center">SHAML Finance & Control</label>
              </div>
            </a>
 
            <a href="https://shamlcore.awjholding.com/sap/bc/ui2/flp" target="_blank">
              <div className="bg-primary-50/50 flex-col rounded-lg content-center items-center gap-1  md:px-3  md:py-2   xl:px-6 xl:py-4 2xl:px-6 2xl:py-4  flex max-xs:p-4">
                <img className="" src="images/project.svg"/>
                <label className="font-semibold  text-primary-500 text-center">SHAML Portfolio & Project Mgt</label>
              </div>
            </a>
          </div>
 
          <div className="search w-5/6 2xl:w-3/6 justify-self-center flex md:pt-2 xl:pt-4 2xl:pt-6 max-xs:w-full max-xs:px-4 max-xs:pt-4 max-xs:block md:w-full md:px-4 lg:px-6">
            <div className="flex gap-3 w-full border border-primary-500/50 rounded-lg   max-xs:block overflow-hidden">
              {/* Resizable dropdown with limits */}
              <div>
                <ResizableDropdown
                  groups={groups}
                  selectedGroup={selectedGroup}
                  setSelectedGroup={setSelectedGroup}
                />
              </div>

              {/* Divider */}
              <div className="w-[1px] bg-primary-500/50 my-1 max-xs:hidden"></div>

              {/* Search input */}
              <div className="flex w-full px-4 py-3 overflow-hidden">
                <input
                  type="text"
                  className="w-full text-primary-500 bg-transparent text-xl px-2 py-2 focus:outline-none"
                  placeholder="Please search relevant training materials & user guide..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <img src="images/search.svg" className="w-[28px] ml-2 shrink-0" alt="search" />
              </div>
            </div>
          </div>
        </div>
 
        <div className="main-content overflow-x-hidden 2xl:px-72 xl:px-6 2xl:gap-6 flex gap-8 pt-4 xl:gap-4 max-xs:grid max-xs:px-4 md:px-4 ">
          <div className="2xl:w-9/12 lg:w-9/12 md:w-full">
            <TrainingVideosSection filteredMaterials={filteredMaterials} selectedGroup={selectedGroup}/>
          </div>
 
          <div className="2xl:w-3/12 lg:w-3/12 md:w-7/12">
            <UserManualSection filteredMaterials={filteredMaterials} selectedGroup={selectedGroup} />

            <div  className=" grid    hd:grid-cols-1 hd:gap-2 4xl:grid-cols-2 4xl:gap-2">
              <div className="card drop-shadow-card bg-primary-300 p-4 rounded-2xl mt-4">
                <div
                  className="flex gap-4 cursor-pointer items-end"
                  onClick={handleOpen}
                >
                  <img src="images/userguide.svg" alt="User Guide" />
                  <div className="text-white">
                    <h1 className="text-xl font-bold pb-0">How to Use</h1>
                    <p className="text-wrap">View Document</p>
                  </div>
                </div>
              </div>
              
              {isOpen && (
                <PDFPopup
                  fileUrl={fileUrl}
                  title="User Guide"
                  onClose={handleClose}
                />
              )}
              
              <a
                href="https://daam.awjholding.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer"
                style={{ cursor: 'pointer' }}
              >
                <div className="card drop-shadow-card bg-white p-4 rounded-2xl mt-4  ">
                  <div className="flex gap-4 cursor-pointer items-end">
                    <img src="images/support.svg"></img>
                    <div className="">
                      <h1 className="text-xl font-bold text-primary-500 pb-0">Support</h1>
                      <p className="text-[#807A63] text-wrap " >Click Here.</p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* ERP Release Popup - Only shows for group "2" and within 3-day date range */}
      {showERPPopup && (
        <ERPReleasePopup 
          isOpen={showERPPopup} 
          onClose={() => setShowERPPopup(false)} 
          
        />
      )}
    </div>
  );
}

export default HomePage;